var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 247,
    height: 248,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#user_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 247,
    y: 0.036,
    fill: "#87AACA",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M223.419 252.798a7.826 7.826 0 0 1-6.779 3.913H28.818a7.825 7.825 0 0 1-6.77-11.739c14.9-25.757 37.858-44.226 64.652-52.981a70.432 70.432 0 1 1 72.058 0c26.794 8.755 49.753 27.224 64.651 52.981a7.824 7.824 0 0 1 .01 7.826Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "user_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 247,
    height: 247,
    y: 0.036,
    fill: "#fff",
    rx: 5
  })))));
};
export default SvgUser;